var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_vm._v(" "+_vm._s(_vm.$t('in_progress'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }